interface FileListProps {
  files: File[];
  onRemoveFile?: (file: File) => void;
}

function FileList({ files, onRemoveFile }: FileListProps): JSX.Element | null {
  if (files.length === 0) {
    return null;
  }

  return (
    <div className="App-files-section">
      <div className="App-files-header">
        <h3 className="App-files-title">Selected Files</h3>
        <span className="App-files-count">{files.length} file{files.length !== 1 ? 's' : ''}</span>
      </div>
      <div className="App-files-list">
        {files.map(function renderFile(file: File): JSX.Element {
          const sizeKb = Math.round(file.size / 102.4) / 10;
          return (
            <div key={file.name + file.size + file.lastModified} className="App-file-item">
              <div className="App-file-icon">📄</div>
              <div className="App-file-info">
                <div className="App-file-name">{file.name}</div>
                <div className="App-file-size">{sizeKb} KB</div>
              </div>
              {onRemoveFile && (
                <button
                  type="button"
                  className="App-file-remove-button"
                  aria-label={`Remove ${file.name}`}
                  onClick={function handleRemove(): void {
                    onRemoveFile(file);
                  }}
                >
                  x
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default FileList;

